<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">CONTENTS</p>
<p class="toc"><a href="#/preface">Preface</a></p>
<p class="toc"><a href="#/acknowledgement">Acknowledgements</a></p>
<p class="toc"><a href="#/introduction">Introduction</a></p>
<p class="toc1"><a href="#/chapter1">1. “Where a Goat Can Go, a Man Can Go”</a></p>
<p class="toc"><span href="#/chapter2" title="Link target outside of Sample">2. Evacuation</span></p>
<p class="toc"><span href="#/chapter3" title="Link target outside of Sample">3. Pursuit</span></p>
<p class="toc"><span href="#/chapter4" title="Link target outside of Sample">4. First Blood at Sucker Brook</span></p>
<p class="toc"><span href="#/chapter5" title="Link target outside of Sample">5. Fraser Attacks Monument Hill</span></p>
<p class="toc"><span href="#/chapter6" title="Link target outside of Sample">6. The Path up Zion Hill Leads to Deception</span></p>
<p class="toc"><span href="#/chapter7" title="Link target outside of Sample">7. Acland’s Grenadiers to the Rescue</span></p>
<p class="toc"><span href="#/chapter8" title="Link target outside of Sample">8. Hard Fighting on Monument Hill</span></p>
<p class="toc"><span href="#/chapter9" title="Link target outside of Sample">9. Baron von Riedesel Saves the Day</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">10. The Death of Colonel Francis</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">11. The Patriot Line Breaks</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">12. Fraser Holds the Field</span></p>
<p class="toc"><span href="#/chapter13" title="Link target outside of Sample">13. Conclusion</span></p>
<p class="toc1"><span href="#/notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?413b5897